import React, { useState } from "react";
import { Dropdown } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { useTranslation } from "../../../../../app/i18n/LanguageContext";

const LanguageSwitcher = ({ color = "#777777" }) => {
   const { language, languages, setLanguageCode, t } = useTranslation();
   const [open, setOpen] = useState(false);

   return (
      <Dropdown
         trigger={["click"]}
         placement="bottomRight"
         overlayClassName="language-switcher-dropdown"
         open={open}
         onOpenChange={setOpen}
         menu={{
            items: languages.map((option) => ({
               key: option.code,
               label: (
                  <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                     {option.label} ({option.code.toUpperCase()})
                  </span>
               )
            })),
            selectedKeys: [language.code],
            onClick: ({ key }) => setLanguageCode(key)
         }}
      >
         <div
            className="bell"
            role="button"
            tabIndex={0}
            aria-haspopup="menu"
            aria-expanded={open}
            aria-label={`${t("language-selector-label")} — ${language.label}`}
            onKeyDown={(e) => {
               if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setOpen((prev) => !prev);
               }
            }}
         >
            <GlobalOutlined style={{ fontSize: "20px", color }} />
         </div>
      </Dropdown>
   );
};

export default LanguageSwitcher;
